<script>
//Repositories
import Repositories from '@/repositories';
const OrdersRepository = Repositories.get('orders');
const OrderItemsRepository = Repositories.get('orderitems');

//Mixins
import dateMixin from '@/mixins/dateMixin';

//Main components
import Header from './components/header.vue';
import OrderItemsList from './components/order-items-list.vue';
import ReceptionsList from '@/components/widgets/receptions/list';
import Messages from '@/components/widgets/order-messages/list';

//Other components
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import ConfirmButton from '@/components/widgets/buttons/confirmation-button';
import ErrorView from '@/router/views/utility/error';

//Modals
import ToOrderModal from '../shared/modals/to-order.vue';
import ConfirmOrderModal from '../shared/modals/confirm-order.vue';

export default {
  props: {
    orderIdPublic: String,
  },
  components: {
    Header,
    OrderItemsList,
    ReceptionsList,
    Messages,
    Loading,
    ConfirmButton,
    ErrorView,
    ToOrderModal,
    ConfirmOrderModal,
  },
  mixins: [dateMixin],
  data() {
    return {
      order: null,
      orderItemsList: [],
      isLoading: false,
      confirmOrderError: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      if (this.orderIdPublic.length > 0) {
        this.isLoading = true;
        let promise1 = OrdersRepository.get(this.orderIdPublic).then(
          (response) => {
            this.order = response.data;
          }
        );

        let promise2 = OrderItemsRepository.customREST
          .getByOrderWithWorkOrderItemOrderItems(this.orderIdPublic)
          .then((response) => {
            console.log(response);

            this.orderItemsList = response.data;
          });

        Promise.all([promise1, promise2])
          .catch(() => {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          })
          .finally(() => (this.isLoading = false));
      }
    },
    orderUpdated(updatedOrder) {
      this.order = updatedOrder;
    },
    orderOrder() {
      this.$bvModal.show('to-order-modal');
    },
    confirmOrder() {
      this.$bvModal.show('confirm-order-modal');
    },
    orderItemAdded() {
      this.loadData();
    },
    orderItemUpdated(orderItem) {
      let foundIndex = this.orderItemsList.findIndex(
        (x) => x.idPublic == orderItem.idPublic
      );

      if (foundIndex >= 0) {
        this.orderItemsList = [
          ...this.orderItemsList.slice(0, foundIndex),
          orderItem,
          ...this.orderItemsList.slice(foundIndex + 1),
        ];
      }
    },
    orderItemDeleted(orderItemIdPublic) {
      let foundIndex = this.orderItemsList.findIndex(
        (x) => x.idPublic == orderItemIdPublic
      );
      this.orderItemsList.splice(foundIndex, 1);
    },
    closeOrder() {
      this.confirmOrderError = false;

      OrdersRepository.actions
        .closeOrder(this.order.idPublic)
        .then(() => {
          this.confirmOrderError = false;

          this.order = { ...this.order, isClosed: true };
        })
        .catch((error) => {
          this.confirmOrderError = true;

          if (error.response.status == 409) {
            this.$toast.warningToast(this.$t('errors.wasDesyncedTryAgainBulk'));
          } else {
            this.$toast.errorToast(this.$t('errors.errorLoading'));
          }
        });
    },
  },
};
</script>

<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      color="#f1b44c"
      :width="70"
      :height="70"
      loader="dots"
      :is-full-page="false"
    >
    </loading>
    <div v-if="order != null">
      <Header
        :order="order"
        :orderItemsList="orderItemsList"
        @order-updated="orderUpdated"
        @order-item-added="orderItemAdded"
      />

      <!-- Third row order items and messages -->
      <b-container fluid>
        <b-row>
          <b-col xl="8" lg="12">
            <OrderItemsList
              :orderItemsList="orderItemsList"
              :supplierIdPublic="order.supplierIdPublic"
              @order-item-updated="orderItemUpdated"
              @order-item-deleted="orderItemDeleted"
            />
            <b-button
              v-if="
                order.isOrdered == false &&
                  order.supplierStatus == 'TO_ORDER' &&
                  orderItemsList.length > 0
              "
              block
              variant="primary"
              @click="orderOrder"
              style="margin-top: 20px"
            >
              {{ $t('orders.orderr') }}
            </b-button>
            <b-button
              v-else-if="
                order.isOrdered == false &&
                  order.supplierStatus == 'CONFIRMED' &&
                  orderItemsList.length > 0
              "
              block
              variant="primary"
              @click="confirmOrder"
              style="margin-top: 20px"
            >
              {{ $t('orders.orderr') }}
            </b-button>
            <ConfirmButton
              v-else
              :confirmationText="$t('general.areYouSureClose')"
              @clicked="closeOrder"
              :error="confirmOrderError"
            >
              {{ $t('orders.closeOrder') }}
            </ConfirmButton>
          </b-col>

          <b-col xl="4" lg="12">
            <ReceptionsList :orderIdPublic="orderIdPublic" />
            <Messages
              :orderIdPublic="orderIdPublic"
              :userIdPublic="$store.state.user.config.idPublic"
              :internalView="true"
            />
          </b-col>
        </b-row>

        <ToOrderModal :order="order" @order-updated="orderUpdated" />
        <ConfirmOrderModal :order="order" @order-updated="orderUpdated" />
      </b-container>
    </div>
    <ErrorView
      :message="$t('orders.orderNotFound')"
      v-if="order == null && isLoading == false"
    />
  </div>
</template>
